import { render, staticRenderFns } from "./InventoryWrite.vue?vue&type=template&id=45a7d591&scoped=true"
import script from "./InventoryWrite.vue?vue&type=script&lang=js"
export * from "./InventoryWrite.vue?vue&type=script&lang=js"
import style0 from "./InventoryWrite.vue?vue&type=style&index=0&id=45a7d591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7d591",
  null
  
)

export default component.exports